import varAxios from "../../Comman/axios";
import formDataAxios from "../../Comman/formDataAxios";
import {  fetchNotificationSettingsUrl,
         insertNotificationSettingsUrl,
         fetchNotificationTypesUrl,
         updateNotificationSettingsUrl,
         deleteNotificationSettingsUrl ,
         fetchNotificationCategoryUrl,
         fetchFontTypeUrl,GetRegionListUrl
        } from "../../Comman/apiEndPoints"

 export const  FETCH_FONT_TYPE_REQUEST= "(fetch) FETCH FONT TYPE REQUEST";
 export const  FETCH_FONT_TYPE_SUCCESS= "(fetch) FETCH FONT TYPE SUCCESS";
 export const  FETCH_FONT_TYPE_ERROR= "(fetch) FETCH FONT TYPE ERROR";
export const FETCH_REGION_LIST_DATA = "FETCH_REGION_LIST_DATA";
export const FETCH_NOTIFICATION_TYPE_REQUEST = "(fetch) FETCH NOTIFICATION TYPE REQUEST";
export const FETCH_NOTIFICATION_TYPE_SUCCESS = "(fetch) FETCH NOTIFICATION TYPE SUCCESS";
export const FETCH_NOTIFICATION_TYPE_ERROR = "(fetch) FETCH NOTIFICATION TYPE ERROR";
 
export const FETCH_NOTIFICATION_CATEGORY_REQUEST = "(fetch) FETCH NOTIFICATION CATEGORY REQUEST";
export const FETCH_NOTIFICATION_CATEGORY_SUCCESS = "(fetch) FETCH NOTIFICATION CATEGORY SUCCESS";
export const FETCH_NOTIFICATION_CATEGORY_ERROR = "(fetch) FETCH NOTIFICATION CATEGORY ERROR";

export const FETCH_NOTIFICATION_SETTINGS_REQUEST = "(fetch) FETCH NOTIFICATION SETTINGS REQUEST";
export const FETCH_NOTIFICATION_SETTINGS_SUCCESS = "(fetch) FETCH NOTIFICATION SETTINGS SUCCESS";
export const FETCH_NOTIFICATION_SETTINGS_ERROR = "(fetch) FETCH NOTIFICATION SETTINGS ERROR";

export const UPDATE_NOTIFICATION_SETTINGS_REQUEST = "(update) UPDATE NOTIFICATION SETTINGS REQUEST";
export const UPDATE_NOTIFICATION_SETTINGS_SUCCESS = "(update) UPDATE NOTIFICATION SETTINGS SUCCESS";
export const UPDATE_NOTIFICATION_SETTINGS_ERROR = "(update) UPDATE NOTIFICATION SETTINGS ERROR";

export const INSERT_NOTIFICATION_SETTINGS_REQUEST = "(insert) INSERT NOTIFICATION SETTINGS REQUEST";
export const INSERT_NOTIFICATION_SETTINGS_SUCCESS = "(insert) INSERT NOTIFICATION SETTINGS SUCCESS";
export const INSERT_NOTIFICATION_SETTINGS_ERROR = "(insert) INSERT NOTIFICATION SETTINGS ERROR";

export const DELETE_NOTIFICATION_SETTINGS_REQUEST = "(delete) DELETE NOTIFICATION SETTINGS REQUEST";
export const DELETE_NOTIFICATION_SETTINGS_SUCCESS = "(delete) DELETE NOTIFICATION SETTINGS SUCCESS";
export const DELETE_NOTIFICATION_SETTINGS_ERROR = "(delete) DELETE NOTIFICATION SETTINGS ERROR";
export const Fetch_All_Region_Data1 = "Fetch_All_Region_Data1";

var statusCode=""
 
export function fetchFontType(dispatch) { 
    return (dispatch) => {
        dispatch(fetchFontTypeRequest(true));

        return varAxios.get(fetchFontTypeUrl)
            .then((response) => { 
                dispatch(
                    fetchFontTypeSuccess(false, response.data.GlobalSettings)
                );
            })
            .catch((error) => {
            })
    }
}

export function fetchFontTypeRequest(isLoading) {
    return {
        type: FETCH_FONT_TYPE_REQUEST,
        isLoading
    }
}

export function fetchFontTypeSuccess(isLoading, fontType) {   
    return {
        type: FETCH_FONT_TYPE_SUCCESS,
        isLoading,
        fontType
    }
}

export function fetchNotificationCategory(dispatch) { 
    return (dispatch) => {
        dispatch(fetchNotificationCategoryRequest(true));

        return varAxios.get(fetchNotificationCategoryUrl)
            .then((response) => { 
                dispatch(
                    fetchNotificationCategorySuccess(false, response.data.Notifications)
                );
            })
            .catch((error) => {
            })
    }
}

export function fetchNotificationCategoryRequest(isLoading) {
    return {
        type: FETCH_NOTIFICATION_CATEGORY_REQUEST,
        isLoading
    }
}

export function fetchNotificationCategorySuccess(isLoading, notificationCategory) {//notificationCategoryDet
    // var notificationCategory = [];
    // notificationCategory.push({
    //     CategoryId: "",
    //     Notificationcategory: "Select"
    // });
    // for (var i = 0; i < notificationCategoryDet.length; i++) {
    //     notificationCategory.push({
    //         CategoryId: notificationCategoryDet[i].CategoryId,
    //         Notificationcategory: notificationCategoryDet[i].Notificationcategory,

    //     });
    // }
    return {
        type: FETCH_NOTIFICATION_CATEGORY_SUCCESS,
        isLoading,
         notificationCategory
    }
}

export function fetchNotificationSettings(RegionId,dispatch) { 
    return (dispatch) => {
        dispatch(fetchNotificationSettingsRequest(true));

        return varAxios.post(fetchNotificationSettingsUrl,RegionId,
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
            .then((response) => { 
                dispatch(
                    fetchNotificationSettingsSuccess(false, response.data.Notifications)
                );
            })
            .catch((error) => {
            })
    }
}

export function fetchNotificationSettingsRequest(isLoading) {
    return {
        type: FETCH_NOTIFICATION_SETTINGS_REQUEST,
        isLoading
    }
}

export function fetchNotificationSettingsSuccess(isLoading, notificationList) {
    return {
        type: FETCH_NOTIFICATION_SETTINGS_SUCCESS,
        isLoading,
        notificationList
    }
}

export function fetchNotificationTypes(dispatch) { 
    return (dispatch) => {
        dispatch(fetchNotificationTypesRequest(true));

        return varAxios.get(fetchNotificationTypesUrl)
            .then((response) => { 
                dispatch(
                    fetchNotificationTypesSuccess(false, response.data.NotificationTypes)
                );
            })
            .catch((error) => {
            })
    }
}

export function fetchNotificationTypesRequest(isLoading) {
    return {
        type: FETCH_NOTIFICATION_TYPE_REQUEST,
        isLoading
    }
}

export function fetchNotificationTypesSuccess(isLoading, notificationType) {//notificationTypeDet
    // var notificationType = [];
    // notificationType.push({
    //     TypeId: "",
    //     Type: "Select"
    // });
    // for (var i = 0; i < notificationTypeDet.length; i++) {
    //     notificationType.push({
    //         TypeId: notificationTypeDet[i].TypeId,
    //         Type: notificationTypeDet[i].Type,

    //     });
    // }
    return {
        type: FETCH_NOTIFICATION_TYPE_SUCCESS,
        isLoading,
        notificationType
    }
}


export function insertNotificationSettings(isLoading, notificationSettingsList, dispatch) {
    return (dispatch) => {
        dispatch(insertNotificationSettingsDetailRequest(true)); 
        return formDataAxios.post(insertNotificationSettingsUrl, notificationSettingsList,
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
            .then((response) => {

                dispatch(
                    insertNotificationSettingsDetailSuccess(false,
                     response.data.notificationList, 
                     response.data.Message,
                     response.data.statusCode
                     
                     )
                );
            })
            .catch((error) => {
            })
    }
}


export function insertNotificationSettingsDetailRequest(isLoading) {
    return {
        type: INSERT_NOTIFICATION_SETTINGS_REQUEST,
        isLoading 
         
    }
}

export function insertNotificationSettingsDetailSuccess(isLoading, notificationList, messageLabel,statusCode) {
    return {
        type: INSERT_NOTIFICATION_SETTINGS_SUCCESS,
        isLoading,
        notificationList,
        messageLabel,
        statusCode
    }
}

export function updateNotificationSettings(isLoading, notificationList,region, dispatch) {

    return (dispatch) => {
        dispatch(updateNotificationSettingsDetailRequest(true));

        return formDataAxios.post(updateNotificationSettingsUrl, notificationList,
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
            .then((response) => {
                console.log(response)
                dispatch(
                    updateNotificationSettingsDetailSuccess(false,
                     response.data.List, 
                     response.data.Message,
                     response.data.statusCode
                     )
                );
                this.fetchNotificationSettings({RegionId:region})
            })
            .catch((error) => {
            })
    }
}


export function updateNotificationSettingsDetailRequest(isLoading) {
    return {
        type: UPDATE_NOTIFICATION_SETTINGS_REQUEST,
        isLoading,
        statusCode
    }
}

export function updateNotificationSettingsDetailSuccess(isLoading, notificationList, messageLabel,statusCode) {
    return {
        type: UPDATE_NOTIFICATION_SETTINGS_SUCCESS,
        isLoading,
        notificationList,
        messageLabel,
        statusCode
    }
}


export function deleteNotificationSettings(isLoading, notificationSettingsID,RegionId, dispatch) {
    console.log(notificationSettingsID)
    return (dispatch) => {
        dispatch(deleteNotificationSettingsDetailRequest(true));

        return varAxios.delete(deleteNotificationSettingsUrl, { data: notificationSettingsID },
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
            .then((response) => {
                
                dispatch(
                    deleteNotificationSettingsDetailSuccess(false, 
                        response.data.List, 
                        response.data.Message,
                        response.data.statusCode

                        )
                );
                     return Promise.resolve(response.data);
                //this.fetchNotificationSettings(RegionId)
            })
            .catch((error) => {
            })
    }
}


export function deleteNotificationSettingsDetailRequest(isLoading) {
    return {
        type: DELETE_NOTIFICATION_SETTINGS_REQUEST,
        isLoading,
        statusCode
    }
}

export function deleteNotificationSettingsDetailSuccess(isLoading, notificationList, errorMessage,statusCode) {
    return {
        type: DELETE_NOTIFICATION_SETTINGS_SUCCESS,
        isLoading,
        notificationList,
        errorMessage,
        statusCode
    }
}
  export function getAllRegionSettings() {
      let requestPayload={
    UserId:sessionStorage.getItem('SuperAdminUserID')
  }
    return(dispatch) =>{
       return varAxios.post(GetRegionListUrl,requestPayload,
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
       .then(response => {
       
       
       
          dispatch(
            fetchAllRegionData({
              errorCode : response.data.errorCode,
              statusCode : 206,
              regionList : response.data.regionList
             }));
              this.fetchNotificationSettings({RegionId:response.data.regionList[0].ID});
        this.getPredefinedTextListFunc({RegionId:response.data.regionList[0].ID})
       })
       .catch((error) => {
          console.log("error",error);
      })
    }
}
export function fetchAllRegionData({errorCode, statusCode, regionList}) {
  return {
    type : Fetch_All_Region_Data1,
    errorCode,
    statusCode,
    regionList
  }
}
export function getRegionListFunc() {
    let requestPayload={
    UserId:sessionStorage.getItem('SuperAdminUserID')
  }
    return(dispatch) =>{
       return varAxios.post(GetRegionListUrl,requestPayload,
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
       .then(response => {
        
           if(response.data.statusCode == 200){
           
            dispatch(
                fetchRegionListData(response.data.regionList)
                );
           }
       })
       .catch((error) => {
          console.log("error",error);
      })
    }
}
export function fetchRegionListData(list) {
    return {
        type: FETCH_REGION_LIST_DATA,
        list
    }
}
